// @flow
import React, {Component} from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  View,
  TouchableWithoutFeedback,
  Platform,
} from 'react-native';
import {RCTModal} from './RCTModal';
import theme from '../../../theme-config';
import Icon from '../Icon/Icon';

class Modal extends Component<PropsTypes> {
  styles = getStyles();
  render() {
    const {visible = false} = this.props;
    const styles = this.styles;
    return (
      <View>
        <RCTModal
          animationType="fade"
          transparent
          visible={visible}
          onRequestClose={this.props.requestClose}>
          <TouchableWithoutFeedback onPress={this.props.requestClose}>
            <View style={[styles.modalBackground, this.props.backgroundStyle]}/>
          </TouchableWithoutFeedback>
          <View style={[
                Platform.OS === 'web' ? styles.modalWeb : styles.modal,
                this.props.fullScreen && styles.fullScreenModal,
                this.props.style,
              ]}>
              {this.props.children}
          </View>
          <View style={styles.iconContainer}>
            <TouchableOpacity
              onPress={this.props.requestClose}
              activeOpacity={0.6}>
              <Icon name="cross" style={styles.icon} size={20} />
            </TouchableOpacity>
          </View>
        </RCTModal>
      </View>
    );
  }
}

type PropsTypes = {
  requestClose: Function,
  visible: boolean,
  children?: any,
  style?: any,
  backgroundStyle?: any,
  fullScreen?: boolean,
};

function getStyles() {
  return StyleSheet.create({
    modalBackground: {
      flex: 1,
      backgroundColor: 'black',
      opacity: 0.65,
    },
    modal: {
      position: 'absolute',
      top: 178,
      left: 25,
      right: 25,

      backgroundColor: theme.backgroundColor,
      borderRadius: 5,
      padding: 10,
    },
    modalWeb: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
      opacity: 1,
      backgroundColor: theme.backgroundColor,
      borderRadius: 5,
      padding: 10,
      width: '100%',
      maxWidth: 600,
      alignSelf: 'center',
    },
    fullScreenModal: {
      left: 20,
      right: 20,
      top: 60,
      bottom: 60,
    },
    iconContainer: {
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: 'transparent',
    },
    icon: {
      color: theme.overPrimaryColor,
      paddingHorizontal: 14,
      paddingVertical: 32,
    },
  });
}

export default Modal;
